module.exports = __webpack_public_path__ + "d534fafddee87f2e24825b6a6c9e6ced.svg";